export class RequestGetAllPageAccessibleModel {
  companyId: string;
  empId: string;
  userAccess: UserAccess[];
}

export class UserAccess{
  userId: number;
  usergroupId: number;
  groupName: string;
  companyId: number;
  groupType: number;
  description: string;
  status: number;
  companyCode: string;
}


export class ResponseGetAllPageAccessibleModel{
  message: string;
  data: DataGetAllPageAccessible[];
}

export class DataGetAllPageAccessible{
  pageId?: number;
  pageCode: string;
  result: boolean;
}



// WEBPACK FOOTER //
// ./src/pagebuilder/model/app-page.model.ts